import buildQuery, { ITEM_ROOT } from 'odata-query';

import { conditionalOptions, conditionalProperties, escape, isEmpty } from '../../../utils';

export const createUserFilter = ({
    name,
    email,
    roleId,
}: Partial<{
    name?: string;
    email?: string;
    roleId?: number;
}> = {}): string | undefined => {
    const filter = [
        {
            or: {
                ...conditionalProperties(!isEmpty(name), {
                    Name: {
                        [`tolower(${ITEM_ROOT})`]: {
                            contains: { type: 'raw', value: `'${escape(name ?? '')}'` },
                        },
                    },
                }),
                ...conditionalProperties(!isEmpty(email), {
                    Email: {
                        [`tolower(${ITEM_ROOT})`]: {
                            contains: { type: 'raw', value: `'${escape(email ?? '')}'` },
                        },
                    },
                }),
            },
        },
        ...conditionalOptions(!isEmpty(roleId), [
            {
                UserRoles: {
                    any: { RoleID: { eq: roleId ?? 0 } },
                },
            },
        ]),
    ];

    const query = buildQuery({ filter });

    return query.replace('?$filter=', '') || undefined;
};
